import * as React from 'react';

import Row from 'antd/lib/row';
import Col from 'antd/lib/col';

import {
  Props,
} from 'one-ui';

const defaultTitleClass = "box__title box__title--gray"
export interface BoxChartHeaderProps extends Props {
  title?: string;
  titleclass?:string;
}

export const BoxChartHeader = ({
  title,
  children,
  titleclass=defaultTitleClass,
}: BoxChartHeaderProps) => (
    <div className="box__top">
      <Row
        type="flex"
        gutter={[8, 0]}
        justify={'space-between'}
        className={'ant-row-nowrap'}
      >
        <Col>
          <div className={titleclass}>
            {title}
          </div>
        </Col>
        <Col>
          <div className="box__actions">
            {children}
          </div>
        </Col>
      </Row>
    </div>
  );

